import React from "react";
// import "contents/assets/scss/page/statistics.scss";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement);

function VerticalBarChart(props) {
  const chartOptions = {
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      y: {
        beginAtZero: true,
      },
    },
    plugins: {
      legend: {
        display: false, // Set this to false to hide the legend
      },
    },
  };
  // Set the desired bar thickness for each dataset
  const barThickness = 10;

  // Set the bar thickness and gap for each dataset
  props.data.datasets.forEach((dataset) => {
    dataset.barThickness = barThickness; // Set the desired bar thickness
  });

  return (
    <div
      className="chart-container"
      style={{ width: props.width, height: props.height }}
    >
      <Bar data={props.data} options={chartOptions} />
    </div>
  );
}

export default VerticalBarChart;
